/**
 * @page security store
 * @author
 * @Date 2018/7/2
 */

import {
  observable,
  action,
  computed,
  configure,
  makeAutoObservable,
} from 'mobx';

import { GuideType } from '../components/GuideBox';

configure({
  enforceActions: 'always',
});

class guideStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      guideFrom: observable,
      guideList: observable,
      hasGuide: observable,
      isShow: observable,
      guideStateList: computed,
      setGuideList: action,
      cleanGuide: action,
      showGuide: action,
      closeGuide: action,
    });

    this.rootStore = rootStore;
  }

  guideFrom = '';
  guideList = [];
  hasGuide = false;

  isShow = false;

  get guideStateList() {
    const finishList = [];
    const willList = [];
    const { profileStore, securityStore } = this.rootStore;
    this.guideList.slice().forEach((item) => {
      let state = false;
      switch (item) {
        case GuideType.kyc1:
          state = profileStore.profile.kycLevel >= 1;
          break;
        case GuideType.kyc2:
          state = profileStore.profile.kycLevel >= 2;
          break;
        case GuideType.step2:
          state =
            securityStore.securityInfo.phoneExist ||
            securityStore.securityInfo.googleExist;
          break;
        case GuideType.email:
          state = securityStore.securityInfo.emailExist;
          break;
        case GuideType.tradePwd:
          state = securityStore.securityInfo.tradePwdExist;
          break;
        default:
          break;
      }
      const line = {
        type: item,
        state,
      };
      if (state) {
        finishList.push(line);
      } else {
        willList.push(line);
      }
    });

    return {
      finishList,
      willList,
    };
  }

  /**
   * 设置引导
   * @param guideFrom  触发点
   * @param guideList  需要校验的列表
   */
  setGuideList(guideFrom, guideList) {
    this.guideFrom = guideFrom;
    this.guideList = guideList;
    this.hasGuide = guideList.length > 0;
  }

  cleanGuide() {
    this.isShow = false;
    this.hasGuide = false;
    this.guideList = [];
    this.guideFrom = '';
  }

  showGuide() {
    this.isShow = true;
  }

  closeGuide() {
    this.isShow = false;
  }
}

export default guideStore;
